import { IdType } from 'fulogics-ui-core';
import configuration from '../../configuration';
import ODataFulogicsStore from 'fulogics-ui-core/dist/api/odata/ODataFulogicsStore';
import { createModel } from '@rematch/core';
import { iRootModel } from '../iRootModel';
import Singleton from 'fulogics-ui-core/dist/Singleton';
import fromODataResponse from 'fulogics-ui-core/dist/api/odata/fromODataResponse';
import enOrderState from '../../api/enums/enOrderState';
import { OrderValidationResult } from '../../layout/components/order-error-info/OrderErrorInfo';
import { RemainingTrailerSpace } from '../../layout/components/progress-bar-boxes/ProgressBarBoxes';

export const COSOrdersODataEndpoint = `${configuration.API_BASE_URL}/odata/COSOrders/Store`;
export const COSOrdersStore = ODataFulogicsStore({
    url: COSOrdersODataEndpoint,
    key: 'id',
    keyType: 'String',
});

export type COSOrdersState = {};

export const COSOrdersModel = createModel<iRootModel>()({
    state: {
        //store: COSOrdersStore
    } as COSOrdersState,

    effects: (dispatch) => ({
        async sendOrder(payload: sendOrderPayload) {
            await COSOrdersStore.update(payload.id, {
                state: payload?.asDraft ? enOrderState.Draft : enOrderState.SendingInProgress,
                draftCloseDeadline: payload?.asDraft
                    ? payload.draftCloseDeadline?.toISOString()
                    : new Date()?.toISOString(),
            });
        },
        async createNew(payload: createNewPayload) {
            let createNewResponse = await Singleton.apiClient.post<{
                title?: string;
                detail?: string;
                id?: string;
            }>('/odata/COSOrders/createNew', {});
            fromODataResponse(createNewResponse, [200, 204]);

            return { id: createNewResponse.data?.id };
        },
        async acquireLock(payload: acquireLockPayload) {
            let acquireLockResponse = await Singleton.apiClient.post<{
                title?: string;
                detail?: string;
            }>('/odata/COSOrders/acquireLock', {
                id: payload.id,
            });
            //
            fromODataResponse(acquireLockResponse, [200, 204]);
        },
        async releaseLock(payload: releaseLockPayload) {
            let releaseLockResponse = await Singleton.apiClient.post<{
                title?: string;
                detail?: string;
            }>('/odata/COSOrders/releaseLock', {
                id: payload.id,
            });
            //
            fromODataResponse(releaseLockResponse, [200, 204]);
        },
        async renewLock(payload: renewLockPayload) {
            let renewLockResponse = await Singleton.apiClient.post<{
                title?: string;
                detail?: string;
            }>('/odata/COSOrders/renewLock', {
                id: payload.id,
            });
            //
            fromODataResponse(renewLockResponse, [200, 204]);
        },
        async singleByIdWithKeys<T>(payload: singleByIdWithKeysPayload): Promise<T | undefined> {
            if (!payload.id) return undefined;
            //
            let kk = payload.keys.filter((n: any, i: any) => payload.keys.indexOf(n) === i);
            //
            const r = await COSOrdersStore.byKey(payload.id, { select: kk });
            //
            if (payload.data) Object.assign(payload.data, payload.data, r);
            //
            return (payload.data ?? r) as T;
        },
        async validate(payload: validateOrderPayload) {
            const validateResponse = await Singleton.apiClient.post<{
                validationResult?: OrderValidationResult;
            }>(`/odata/COSOrders/validate`, {
                id: payload.id,
            });
            //
            fromODataResponse(validateResponse, [200, 204]);

            return validateResponse?.data?.validationResult;
        },
        async getRemainingForwardTrailerSpace(payload: getRemainingForwardTrailerSpacePayload) {
            const validateResponse = await Singleton.apiClient.get<{
                remainingTrailerSpace?: RemainingTrailerSpace;
            }>(
                `odata/COSOrders/GetRemainingForwardTrailerSpace(orderId='${
                    payload.id
                }',defaultOnly='${payload.defaultOnly || false}')`
            );
            fromODataResponse(validateResponse, [200, 204]);

            return validateResponse?.data?.remainingTrailerSpace;
        },
        async getRemainingReturnTrailerSpace(payload: getRemainingReturnTrailerSpacePayload) {
            const validateResponse = await Singleton.apiClient.get<{
                remainingTrailerSpace?: RemainingTrailerSpace;
            }>(
                `odata/COSOrders/GetRemainingReturnTrailerSpace(orderId='${
                    payload.id
                }',defaultOnly='${payload.defaultOnly || false}')`
            );
            fromODataResponse(validateResponse, [200, 204]);

            return validateResponse?.data?.remainingTrailerSpace;
        },
    }),

    // @ts-ignore
    selectors: (slice, createSelector, hasProps) => ({
        dxStore() // OrdersGridItemData // filtrowanie, sortowanie
        {
            return COSOrdersStore;
        },
    }),
});

export type getRemainingReturnTrailerSpacePayload = {
    id: IdType;
    defaultOnly?: boolean;
};

export type getRemainingForwardTrailerSpacePayload = {
    id: IdType;
    defaultOnly?: boolean;
};

export type createNewPayload = {
    // pusty payload
};

export type acquireLockPayload = {
    id: IdType;
};

export type releaseLockPayload = {
    id: IdType;
};

export type renewLockPayload = {
    id: IdType;
};

export type singleByIdWithKeysPayload = {
    id: IdType;
    keys: string[];
    data?: any;
};

export type sendOrderPayload = {
    id: IdType;
    draftCloseDeadline?: Date;
    asDraft?: boolean;
};

export type validateOrderPayload = {
    id: IdType;
};

export default COSOrdersModel;
